import { Model } from 'dva'
import { OrganisationsService } from 'Service'

const AgentCalls: Model = {
  namespace: 'agentCalls',
  state: {
    calls: {},
  },
  effects: {
    *fetchData(
      { callFilter, setLoading = () => {}, onSuccess = () => {}, onError = () => {}, select },
      { call, put }
    ): any {
      try {
        setLoading(true)
        let response = yield call(
          OrganisationsService.organisationsFlowsAnalyticsFetchCallsList,
          callFilter
        )

        if (select) {
          response = select(response)
        }

        yield put({
          type: 'updateCallsList',
          payload: response,
        })
        onSuccess()
      } catch (error) {
        console.log(error)
        onError()
      }
      setLoading(false)
    },
  },
  reducers: {
    updateCallsList(state, action) {
      return {
        ...state,
        calls: action.payload,
      }
    },
  },
}

export default AgentCalls
